import SupportHeroSection from "./components/SupportHeroSection";
import ContactCardsSection from "./components/ContactCardsSection";
import HelpCategoriesSection from "./components/HelpCategoriesSection";
import FAQSection from "./components/FAQSection";

export default function SupportPage() {
  return (
    <>
      <SupportHeroSection />
      <ContactCardsSection />
      <HelpCategoriesSection />
      <FAQSection />
    </>
  );
}
